var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "opt-group" },
    [
      _c("el-date-picker", {
        attrs: {
          type: "date",
          placeholder: _vm.$t("common.placeholder.optionDate"),
          "value-format": "yyyy-MM-dd",
          format: "yyyy-MM-dd",
          disabled: !_vm.isEditable,
        },
        model: {
          value: _vm.record.setterDate,
          callback: function ($$v) {
            _vm.$set(_vm.record, "setterDate", $$v)
          },
          expression: "record.setterDate",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }